<div style="position: relative;">
    <header>
        <div class="header" style="display:block">
            {{heading}}
        </div>
    </header>
    <br>
    <app-audio [playAudio]="playAudio"></app-audio>
    <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage"
    class="notf">
</app-notification-message>
    <div class="body">
       
        <div class="col-md-12">
            <form [formGroup]="addForm" >

                <div class="content">

                    <div class="input">
                        <label class="catlabel">Menu Option</label>
                        <span style="display: flex;">
                                <input type="text" formControlName="menuOption" class="form-control inptwdth"
                                style="text-transform: uppercase;" [maxLength]=1
                                (keypress)="validateMenuOption($event)"
                                 [ngClass]="{'is-invalid': submitted && f['menuOption'].errors}">
                        </span>
                        <div *ngIf="submitted && f['menuOption'].errors" class="invalidFormat">
                            <div *ngIf="f['menuOption'].errors['required']">Menu Option is required</div>
                        </div>
                    </div>

                    <div class="input">
                        <label class="catlabel">Dock</label>
                        <span style="display: flex;">
                                <input type="text" formControlName="dockCode" class="form-control inptwdth"
                                  [ngClass]="{'is-invalid': submitted && f['dockCode'].errors}">
                                  <!-- <option value="" selected disabled hidden></option>
                                  <option  *ngFor="let sp of dockCodeArray" [value]="sp.code">
                                    {{sp.code}}
                                  </option>
                                  </select> -->
                        </span>
                        <div *ngIf="submitted && f['dockCode'].errors" class="invalidFormat">
                            <div *ngIf="f['dockCode'].errors['required']">Dock is required</div>
                        </div>
                    </div>
                </div>
                <br><br>

                <div class="content">

                    <div class="input">
                        <label class="catlabel">Load Type</label>
                        <span style="display: flex;">
                                <input type="text" formControlName="loadType" class="form-control inptwdth"
                                style="text-transform: uppercase;" [maxLength]=2
                                (keypress)="validateLoadType($event)"
                                [ngClass]="{'is-invalid': submitted && f['loadType'].errors}">
                        </span>
                        <div *ngIf="submitted && f['loadType'].errors" class="invalidFormat">
                            <div *ngIf="f['loadType'].errors['required']">Load Type is required</div>
                        </div>
                    </div>
                </div>


            </form>
        </div>

    </div>

    <div class="footerp cfooter">
        <label class="cancel" style="position: relative;
        right: 27px;" (click)="onClick()"> CANCEL
        </label>
        <button *ngIf="eventType == 'ADD'" mat-raised-button class="submit" type="submit" style="display: inline;margin-right: 4%;"
            (click)="submitForm()">SAVE</button>
        <button *ngIf="eventType == 'Edit'" mat-raised-button class="submit" type="submit" style="display: inline;margin-right: 4%;"
            (click)="submitForm()">UPDATE</button>
    </div>

</div>